import { useEffect } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Menu from 'components/Common/Menu'
import { getCompaniesList, getUserRole, getUserData } from 'store/me/selectors'
import { Roles } from 'utils/consts/userRoles'
import Error404 from 'components/Common/Errors/404'
import { ACCOUNT_SETUP_PATH } from 'utils/consts/path'

const AuthenticatedLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const companies = useSelector(getCompaniesList)
  const userRole = useSelector(getUserRole)
  const userData = useSelector(getUserData)

  const isAdmin = userRole !== Roles.PERSON
  const hasNoCompanies = companies.length === 0
  const isAccountSetupRoute = location.pathname.startsWith(ACCOUNT_SETUP_PATH)

  // Проверяем, загружены ли данные пользователя
  // Если данных нет и роль = PERSON (fallback), не применяем логику редиректа
  const isUserDataLoaded =
    userData !== null && userData !== undefined && userData?.id

  useEffect(() => {
    // Применяем логику редиректа только после загрузки данных пользователя
    if (!isUserDataLoaded || isAdmin) {
      return
    }

    if (!isAccountSetupRoute && hasNoCompanies) {
      navigate(ACCOUNT_SETUP_PATH, { replace: true })
    }
  }, [
    isUserDataLoaded,
    companies,
    userRole,
    navigate,
    location.pathname,
    isAdmin,
    hasNoCompanies,
    isAccountSetupRoute,
  ])

  // Block access to all routes except /acc/account-setup when conditions are met
  // Также проверяем, что данные пользователя загружены
  if (isUserDataLoaded && !isAdmin && hasNoCompanies && !isAccountSetupRoute) {
    return <Error404 />
  }

  // Don't show Menu on /acc/account-setup page
  if (isAccountSetupRoute) {
    return <Outlet />
  }

  return (
    <Menu>
      <Outlet />
    </Menu>
  )
}

export default AuthenticatedLayout
